import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { PersonSalaryWarningContentProps } from "models/propTypes/salaryPropTypes";
//#endregion
//#region components
import { useSupportTicketCreateDialog } from "components/support";
import { Grid } from "@mui/material";
import { ActionLinkButton, Icon } from "components/common";
//#endregion
import { LocalizationHelperInstance, UtilsHelper } from "utils/helpers";

const PersonSalaryWarningContent: React.FC<PersonSalaryWarningContentProps> = (props) => {
  const { personSalaryReport } = props;

  const dispatch = useDispatch();
  const { getDialog: getSupportTicketCreateDialog } = useSupportTicketCreateDialog();

  const onOpenSupportTicket = () => {
    dispatch(displayDialog(getSupportTicketCreateDialog()));
  };

  const errors = Array.from(
    new Set(
      personSalaryReport?.rows?.flatMap((r) =>
        r.warningsAndErrors
          ?.filter((e) => e.type !== WintSuperkollAPIModel.PersonSalaryEntryErrorType.UnknownError)
          .map((e) => `${e.message}.`)
      )
    )
  ).join(" ");

  const unknownErrorPersons = Array.from(
    new Set(
      personSalaryReport?.rows?.flatMap((r) =>
        r.warningsAndErrors
          ?.filter((e) => e.type === WintSuperkollAPIModel.PersonSalaryEntryErrorType.UnknownError)
          .map((e) => r.description)
      )
    )
  )
    .filter((s) => !!s)
    .join(", ");

  return !UtilsHelper.isEmpty(errors) || !UtilsHelper.isEmpty(unknownErrorPersons) ? (
    <Grid>
      {!UtilsHelper.isEmpty(errors) ? <Grid>{errors}</Grid> : <></>}
      {!UtilsHelper.isEmpty(unknownErrorPersons) ? (
        <Grid>
          {LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Salary.SomethingWentWrongWithSalaryRows,
            undefined,
            { unknownErrorPersons: unknownErrorPersons }
          )}{" "}
          <ActionLinkButton
            endIcon={<Icon icon={IconDefinitionConstants.WArrowSmallRight} />}
            onClick={onOpenSupportTicket}
          />
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  ) : (
    <></>
  );
};

export default PersonSalaryWarningContent;
